var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:[
        'ui-chip',
        _setup.props.color && `--color-${_setup.props.color}`,
        _setup.props.badge && `--is-badge`,
        _setup.props.isId && `--is-id`,
    ],attrs:{"tabindex":_setup.props.isId ? 0 : undefined}},[_vm._t("prepend"),_vm._t("default"),_vm._t("append")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }